import {InjectionToken} from '@angular/core';
import {UmpireClientConfigService} from '@tisa-group/models';

export const CLIENT_CONFIG = new InjectionToken<UmpireClientConfigService>(
  'Provides config for logged in client',
);
